//#region src/types/migration/Asset.ts
/** A migration asset used with the Prismic Migration API. */
var PrismicMigrationAsset = class {
	/** Asset object from Prismic, available once created. */
	asset;
	/** Configuration of the asset. */
	config;
	/** The initial field value this migration field was created with. */
	originalField;
	/**
	* Creates a migration asset used with the Prismic Migration API.
	*
	* @param config - Configuration of the asset.
	* @param initialField - The initial field value if any.
	* @returns A migration asset instance.
	*/
	constructor(config, initialField) {
		this.config = config;
		this.originalField = initialField;
	}
};
//#endregion
exports.PrismicMigrationAsset = PrismicMigrationAsset;

//# sourceMappingURL=Asset.cjs.map